import { create } from 'zustand'

import { type CoreInsurance } from '@flecto/types'

interface CoreInsuranceState {
  customer: CoreInsurance['customer'] | null
  start_at: CoreInsurance['start_at'] | null
  end_at: CoreInsurance['end_at'] | null

  setLastUpdate: (
    customer: CoreInsurance['customer'],
    start_at: CoreInsurance['start_at'],
    end_at: CoreInsurance['end_at']
  ) => void
}

export const useInsuranceState = create<CoreInsuranceState>((set) => ({
  customer: null,
  start_at: null,
  end_at: null,

  setLastUpdate: (customer, start_at, end_at) =>
    set({ customer, start_at, end_at }),
}))

export default useInsuranceState
